<template>
  <div style="background-color: #EFEFEF">
    <div class="banner">
      <div class="titleSub">Collaboration Cases</div>
      <div class="title wow animate__animated durationTime animate__fadeInUp" id="type">
        合作案例
      </div>
    </div>
    <!--    <div class="news-banner">-->
    <!--      <div class="news-banner-title">-->
    <!--        <div class="news-banner-title-en">NEWS</div>-->
    <!--        <div class="news-banner-title-zh">新闻中心</div>-->
    <!--      </div>-->
    <!--    </div>-->

    <div class="news-nav" id="news-nav">
      <div class="news-nav-pre cus-pointer" @click="jump('/')">
        首页
      </div>
      <img src="../../assets/image/news/jt_right.png" />
      <div class="news-nav-pre cus-pointer" @click="jump('/partner')">
        合作案例
      </div>
      <img src="../../assets/image/news/jt_right.png" />
      <div class="news-nav-current">
        {{ newsDetail.type }}
      </div>
    </div>
    <div class="news-box">
      <div class="news-detail">
        <div class="news-detail-title">
          <div class="news-detail-title-first">
            {{ newsDetail.name }}
          </div>
          <div class="news-detail-title-second">
            <div class="news-detail-title-second-author">
              <img
                style="width: 0.72rem"
                src="../../assets/image/news/news-author.png"
              />
            </div>
            <div class="news-detail-title-second-date">
<!--              {{ newsDetail.time }}-->
            </div>
          </div>
        </div>
        <div
          style="background-color: #999999;border: 0.01rem solid #999999;margin: 0 0.38rem 0.4rem 0.38rem"
        ></div>
        <div style="display: flex;justify-content: center;padding: 0 0.38rem;">
          <div style="line-height: 0.35rem;font-size: 0.16rem;" v-html="newsDetail.detail"></div>
        </div>
        <div
          style="background-color: #999999;border: 0.01rem solid #999999;margin: 0 0.38rem 0.4rem 0.38rem"
        ></div>
        <div class="news-detail-footer">
          <div
            @click="preOrNext(-1)"
            v-if="showPreNews"
            class="news-prev cus-pointer"
          >
            <img src="../../assets/image/news/jt_left.png" />上一篇
          </div>
          <div v-else style="visibility: hidden" class="news-prev cus-pointer">
            <img src="../../assets/image/news/jt_left.png" />上一篇
          </div>
          <div class="news-back-list cus-pointer background-fill" @click="goBack">返回列表</div>
          <div
            @click="preOrNext(1)"
            v-if="showNextNews"
            class="news-next cus-pointer"
          >
            下一篇<img src="../../assets/image/news/jt_right.png" />
          </div>
          <div v-else style="visibility: hidden" class="news-next cus-pointer">
            下一篇<img src="../../assets/image/news/jt_right.png" />
          </div>
        </div>
      </div>
      <div class="news-more">
        <div class="news-more-title">更多案例推荐</div>
        <div
          class="news-more-item cus-pointer"
          v-for="(item, index) in hotNews"
          :key="item.id"
          @click="handleDetail(item.id)"
        >
          <div class="news-more-item-img">
            <img
              style="width: 1.02rem;height: 0.72rem"
              :src="require(`@/assets/${item.imageSrc}`)"
            />
          </div>
          <div class="news-more-item-right">
            <div
              style="font-size: 0.14rem;font-weight: 400;color: #333333;width: 2.18rem"
            >
              {{ item.name }}
            </div>
            <div style="font-size: 0.12rem;font-weight: 400;color: #999999;">
<!--              {{ item.time }}-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import newsData from "./casesData.js";
import {backItem} from "../../util/util";

export default {
  metaInfo() {
    return {
      title: this.metaTitle, // 动态标题
    };
  },
  name: "partnerDetail",
  data() {
    return {
      metaTitle:'',
      showPreNews: true,
      showNextNews: true,
      newsDetail: null,
      hotNews: [],
    };
  },
  //为啥这里进来不是每次执行，在另外一个界面又是每次执行呢？
  // y:路由配置里面，不是每一项都要配置keepAlive:true的，默认不用去配置，当组件需要被缓存时再去配置
  created() {
    let id = this.$route.query.id === undefined ? "1" : this.$route.query.id;
    this.handleData(id);
  },
  watch: {
    "$route.query.id": function(newVal) {
      this.handleData(newVal);
    }
  },
  methods: {
    handleData(id) {
      this.hotNews=[];
      this.newsDetail = newsData.filter(v => id == v.id)[0];
      this.metaTitle=this.newsDetail.name+"_柠檬网联"
      for (let i=0;i<newsData.length;i++){
        if(newsData[i].jump){
          this.hotNews.push(newsData[i]);
        }
      }
      // this.hotNews = newsData.slice(0, 5);
      this.showPreNews = parseInt(id) > 26;
      this.showNextNews = parseInt(id) < 41;
    },
    handleDetail(id) {
      this.handleData(id);
      backItem("news-nav");
    },
    jump(r) {
      this.$router.push({ path: r });
    },
    goBack() {
      this.$router.go(-1);
    },
    preOrNext(step) {
      let s=-1;
      if(step>0){
        s=1;
      }
      let id=parseInt(this.newsDetail.id) + step;
      for (let i=0;i<100;i++){
        if(newsData.filter(v =>id == v.id)[0].jump){
          this.handleDetail(id);
          break;
        }else {
          id=id+s;
        }
      }

      backItem("news-nav");
    },
    // backTop() {
    //   const element = document.getElementById("news-nav");
    //   if (element) {
    //     element.scrollIntoView({ behavior: "smooth" });
    //   }
    // }
  }
};
</script>
<style scoped lang="scss">
.banner {
  width: 100%;
  height: 5.8rem;
  background: url("../../assets/image/partner/bannerBg.png") center no-repeat;
  background-size: cover;

.title {
  font-size: 0.44rem;
  font-weight: 500;
  text-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
  margin-top: 2.75rem;
  margin-left: 2.18rem;
  position: relative;
  color: #fff;
  display: inline-block;
}

.titleSub {
  content: "Collaboration Cases";
  position: absolute;
  margin-top: 2.44rem;
  margin-left: 2.18rem;
  font-size: 0.44rem;
  font-weight: 500;
  color: rgb(169 160 160 / 51%);
  text-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
  letter-spacing: 0.02rem;
}
}
</style>
<style scoped>
.news-box {
  padding: 0.8rem 2.18rem 1.31rem 2.18rem;
  display: flex;
  align-items: self-start;
}
.news-detail {
  width: 10.2rem;
  margin-right: 0.4rem;
  background-color: #ffffff;
}
.news-nav {
  padding: 0.29rem 0 0.29rem 2.18rem;
  background: #ffffff;
  display: flex;
  align-items: center;
}
.news-more {
  width: 4.24rem;
  padding: 0.4rem;
  background-color: #ffffff;
}
.news-detail-title {
  padding: 0.4rem 1.2rem;
}
.news-detail-title-first {
  font-size: 0.32rem;
  font-weight: 500;
  color: #333333;
  margin-bottom: 0.2rem;
  text-align: start;
}
.news-detail-title-second {
  display: flex;
}
.news-detail-title-second-date {
  font-weight: 400;
  font-size: 0.14rem;
  color: #3b5377;
}
.news-detail-title-second-author {
  margin-right: 0.4rem;
}
.news-more-title {
  font-size: 0.22rem;
  font-weight: 500;
  color: #333333;
  margin-bottom: 0.4rem;
}
.news-more-item {
  display: flex;
  justify-content: space-between;
  padding-bottom: 0.2rem;
  border-bottom: 0.01rem solid #999999;
  margin-top: 0.2rem;
}
.news-more-item:last-child {
  border-bottom: 0;
}
.news-more-item:first-child {
  margin-top: 0;
}
.news-more-item-right {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.news-detail-footer {
  padding: 0 0.4rem 0.5rem 0.4rem;
  display: flex;
  justify-content: space-between;
}
.news-prev,
.news-next {
  display: flex;
  align-items: center;
}
.news-prev > img,
.news-next > img,
.news-nav > img {
  width: 0.06rem;
  height: 0.12rem;
}
.news-nav > img {
  margin: 0 0.2rem;
}
.news-prev > img {
  margin-right: 0.1rem;
}
.news-next > img {
  margin-left: 0.1rem;
}
.news-back-list {
  width: 1.4rem;
  height: 0.42rem;
  background-image: url("../../assets/image/solution/solution-four-more.png");
  background-size: 100% 100%; /* 背景图片自适应容器大小 */
  background-repeat: no-repeat; /* 防止背景图片重复 */
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.16rem;
  font-weight: 400;
  color: #333333;
}
.news-back-list:hover{
  clip-path: polygon(0 0, calc(100% - 0.08rem) 0%, 100% 0.08rem, 100% 100%, 0.08rem 100%, 0% calc(100% - 0.08rem));
}
.news-banner {
  width: 100%;
  height: 5.8rem;
  background-image: url("../../assets/image/news/banbg.png");
  background-size: cover; /* 调整背景图片大小以填充div */
  background-position: center; /* 居中显示背景图片 */
}
.news-banner-title-en {
  font-size: 0.44rem;
  font-weight: 500;
  color: #ffffff;
  text-shadow: 0 0.03rem 0.06rem rgba(0, 0, 0, 0.16);
  opacity: 0.5;
  margin-left: 0.2rem;
}
.news-banner-title {
  padding-top: 2.75rem;
  padding-left: 2.18rem;
}
.news-banner-title-zh {
  font-size: 0.44rem;
  font-weight: 500;
  color: #ffffff;
  text-shadow: 0 0.03rem 0.06rem rgba(0, 0, 0, 0.16);
  margin-top: -0.38rem;
}
.news-nav-pre {
  font-size: 0.16rem;
  font-weight: 400;
  color: #999999;
}
.news-nav-current {
  height: 0.22rem;
  font-size: 0.16rem;
  font-weight: 400;
  color: #333333;
}
</style>



// WEBPACK FOOTER //
// src/pages/partner/partnerDetail.vue